module.exports = __webpack_public_path__ + "static/media/logo.e5220bd8.svg";